const getParticipantAndScoresFromRunnerName = (
  runnerName: string
): { participant: string | undefined; homeScore: number; awayScore: number } => {
  const match = runnerName.match(/(?<participant>\w.+?)?\s*(?<home>\d+)\s*-\s*(?<away>\d+)/i);
  const { away = 0, home = 0, participant } = match?.groups ?? {};
  return { participant, homeScore: Number(home), awayScore: Number(away) };
};

export default getParticipantAndScoresFromRunnerName;
